import React from 'react';
import PropTypes from 'prop-types';

export default function POLineItemDescription({ it, updateItem, readOnly = false, schedules = [] }) {
  const scheduleName = it.scheduleId
    ? schedules.find((s) => s.sk === it.scheduleId)?.name
    : null;

  return (
    <div className="li-col li-desc">
      <input
        className="li-client-name-input"
        value={it.name || ''}
        placeholder="Item name"
        disabled={readOnly}
        onChange={(e) => updateItem(it.itemId, { name: e.target.value })}
      />

      <textarea
        className="if-textarea li-description"
        placeholder="Description"
        value={it.description || ''}
        disabled={readOnly}
        onChange={(e) => updateItem(it.itemId, { description: e.target.value })}
      />

      {(it.room || scheduleName) && (
        <div className="po-line-room-schedule">
          {it.room && <span>Room: {it.room}</span>}
          {it.room && scheduleName && <span className="po-line-room-schedule-sep">·</span>}
          {scheduleName && <span>Schedule: {scheduleName}</span>}
        </div>
      )}
    </div>
  );
}

POLineItemDescription.propTypes = {
  it: PropTypes.object.isRequired,
  updateItem: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  schedules: PropTypes.array,
};
